export default class Analytics {

    static getURL() {
        return "https://www.googletagmanager.com/gtag/js"
    }

    gtag() {

        if (!this.isLoaded) {
            return
        }

        this.showDebug(
            "gtag",
            arguments
        )

        window.dataLayer.push(arguments)
    }

    showDebug(pFunction, pArgs) {
        if (this.debug) {
            console.log(pFunction, pArgs)
        }
    }

    event(pName, pOptions) {
        this.gtag("event", pName, pOptions)
    }

    pageView(pOptions) {
        this.gtag("event", "page_view", pOptions)
    }

    load() {

        return new Promise((resolve, reject) => {

            if (!this.isActive) {

                this.showDebug(
                    "loader",
                    "Analytics Inactive"
                )

                return resolve()
            }

            const script = document.createElement(
                "script"
            )

            script.src = (
                Analytics.getURL()
                + "?id="
                + this.tag
            )

            script.async = true

            script.onload = () => {

                this.isLoaded = true
                window.dataLayer = window.dataLayer || []
                this.gtag("js", new Date())
                this.gtag("config", this.tag, this.config)
                this.showDebug(
                    "loader",
                    "Analytics tag: " + this.tag
                )
                resolve()
            }

            script.onerror = () => {

                console.log("GANA Error Loading")
                resolve()
            }

            document.head.appendChild(script)
        })
    }

    setConfig(p) {

        if (!this.isLoaded) {
            this.url = p.url
            this.tag = p.tag
            this.config = p.config
        }
    }

    constructor(p) {

        Object.entries(
            p
        ).forEach(([id, value]) => {
            this[id] = value
        })

        window.addEventListener("ganaEvent", (pEvt) => {
            this.event(
                pEvt.detail.name,
                pEvt.detail.options
            )
        })
    }
}